/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/common';
import { BadgeSummary } from '@/api/types/common';
import { COMMON } from '@/store/types';
import { StoreActionEnv } from '@/store/actions';
import { updateObject } from '@/utils/util';

interface LockInfo {
  all: boolean;
  stuff: boolean;
  message: boolean;
  discover: boolean;
}

export interface StoreCommonBadgeState {
  all: BadgeSummary;
  stuff: BadgeSummary;
  message: BadgeSummary;
  discover: BadgeSummary;
  lock: LockInfo;
}

export default {
  namespaced: true,
  state: {
    all: {},
    stuff: {},
    message: {},
    discover: {},
    lock: {},
  },
  getters: {},
  actions: {
    [COMMON.GET_BADGES]({ state, commit }: StoreActionEnv<StoreCommonBadgeState>, { type, reload, refresh }) {
      if (state.lock[type]) {
        reload = false;
      }
      if (refresh ? state.lock[type] : reload) {
        return new Promise((resolve, reject) => {
          commit(COMMON.GET_BADGES, { status: 'start', type });
          api.getBadges(type).then((res) => {
            commit(COMMON.GET_BADGES, {
              status: 'success',
              type,
              data: res.data,
            });
            resolve();
          }).catch(() => {
            commit(COMMON.GET_BADGES, { status: 'failure', type });
            reject();
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [COMMON.GET_BADGES](state: StoreCommonBadgeState, { status, type, data }) {
      if (!state[type]) {
        return;
      }
      if (status === 'start') {
        state.lock[type] = true;
      } else if (status === 'update') {
        const badges = Object.assign({}, state[type]);
        updateObject(badges, {
          assign: data.assign,
          offset: data.offset,
        });
        state[type] = badges;
      } else {
        if (status === 'success') {
          const badges = Object.assign({}, data);
          if (type === 'message') {
            Object.assign(badges, { chat: state[type].chat });
          }
          state[type] = badges;
        }
        state.lock[type] = false;
      }
    },
  },
};
